import React, { useState, useMemo } from 'react';

import { Dropdown, DropdownItem } from '@vlabs/uikit';
import { connect } from 'react-redux';

import { selectAvailableAnalyticsList } from '@vlabs/pages/video-analytics/selectors';

import { analyticsUiConfigByType } from '@vlabs/pages/video-analytics/analyticsUiConfigByType';
import { getAnalyticOrdinalNumbers } from '@vlabs/pages/video-analytics/getAnalyticOrdinalNumbers';

function AnalyticsDropdownComponent({
  availableAnalyticsList,
  onAnalyticClick,
  placement,
  renderTrigger,
  withOrdinals,
}) {
  const [isOpen, setIsOpen] = useState(false);

  const handleAnalyticClick = (type, index) => {
    onAnalyticClick?.(type, index);
    setIsOpen(false);
  };

  const dropdownContent = useMemo(() => availableAnalyticsList.map((type, index) => {
    const config = analyticsUiConfigByType[type];
    if (!config) return;

    const analyticsOrdinalNumbers = getAnalyticOrdinalNumbers(availableAnalyticsList);
    const ordinals = withOrdinals ? ` ${analyticsOrdinalNumbers[index] ?? index + 1}` : '';
    const label = config?.label + ordinals;

    return (
      <DropdownItem
        key={type}
        label={label}
        leftIcon={config?.icon}
        onClick={() => handleAnalyticClick(type, index)}
      />
    );
  }), [availableAnalyticsList]);

  return (
    <Dropdown
      isOpen={isOpen}
      onClose={() => setIsOpen(false)}
      options={dropdownContent}
      placement={placement}
    >
      {renderTrigger?.({ onClick: () => setIsOpen(!isOpen) })}
    </Dropdown>
  );
}

export const AnalyticsDropdown = connect((state, { availableAnalyticsList }) => ({
  availableAnalyticsList: availableAnalyticsList ?? selectAvailableAnalyticsList(state),
}))(AnalyticsDropdownComponent);
